var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFalkonAiFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.499,
    height: 26.317,
    viewBox: "0 0 30.499 26.317",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "star-gradient-1",
    x1: 0.22,
    y1: 0.246,
    x2: 0.823,
    y2: 0.798,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4c03ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#c00efe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#da0bcc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "star-gradient-2",
    x1: 0.22,
    y1: 0.246,
    x2: 0.823,
    y2: 0.798,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4c03ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.626,
    stopColor: "#c00efe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#da0bcc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "star-gradient-3",
    x1: 0.22,
    y1: 0.246,
    x2: 0.823,
    y2: 0.798,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4c03ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.626,
    stopColor: "#c00efe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#da0bcc"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "star-shadow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 1,
    dy: 1,
    stdDeviation: 1,
    floodColor: "rgba(0, 0, 0, 0.3)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Star_Icon_Group",
    transform: "translate(3.249 -0.077)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Star_Background",
    width: 24,
    height: 24,
    transform: "translate(0 0.077)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star_1",
    d: "M403.092,6.194a14.26,14.26,0,0,1-7.468,7.463.581.581,0,0,0,0,1.067,14.229,14.229,0,0,1,7.444,7.406.612.612,0,0,0,1.124,0,14.255,14.255,0,0,1,7.443-7.406.58.58,0,0,0,0-1.066,14.264,14.264,0,0,1-7.467-7.465.585.585,0,0,0-1.075,0Z",
    transform: "translate(-392.02 -2.71)",
    stroke: "#eee",
    strokeWidth: 0.5,
    fill: "url(#star-gradient-1)",
    filter: "url(#star-shadow)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star_2",
    d: "M525.231,111.366a5.219,5.219,0,0,1-2.366,2.366.346.346,0,0,0,0,.623,5.208,5.208,0,0,1,2.366,2.366.345.345,0,0,0,.621,0,5.218,5.218,0,0,1,2.367-2.367.346.346,0,0,0,0-.621,5.216,5.216,0,0,1-2.366-2.367.346.346,0,0,0-.622,0Z",
    transform: "translate(-504.68 -95.85)",
    stroke: "#eee",
    strokeWidth: 0.5,
    fill: "url(#star-gradient-2)",
    filter: "url(#star-shadow)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star_3",
    d: "M537.823,3.045a7.159,7.159,0,0,1-3.29,3.29.46.46,0,0,0,0,.825,7.139,7.139,0,0,1,3.289,3.289.46.46,0,0,0,.825,0,7.16,7.16,0,0,1,3.288-3.289.46.46,0,0,0,0-.825,7.162,7.162,0,0,1-3.29-3.291.46.46,0,0,0-.825,0Z",
    transform: "translate(-514.94 -0.01)",
    stroke: "#eee",
    strokeWidth: 0.5,
    fill: "url(#star-gradient-3)",
    filter: "url(#star-shadow)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalkonAiFilledIcon);
export default __webpack_public_path__ + "static/media/falkon-ai-filled-icon.dc57cd891570183feea3b1ade8372dda.svg";
export { ForwardRef as ReactComponent };